import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useDonationsStore } from '../store/donationsStore'
import { deleteDonation } from '../utils/deleteDonation'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useDeleteDonationMutation = (onSuccess?: () => void) => {
  const remove = useDonationsStore((state) => state.remove)

  return useMutation({
    mutationFn: deleteDonation,
    onSuccess: ({ message, id }) => {
      remove(id)
      toast.success(message || 'Donation deleted successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while deleting donation.')
    },
  })
}
